// Hand the recovery file to the user as a download. Its text never goes anywhere else.
import type { RecoveryFile } from "./recovery";

export function recoveryFileName(file: RecoveryFile): string {
  return `ocs-account-key-${file.fingerprint.slice(0, 8)}.json`;
}

export function downloadRecoveryFile(file: RecoveryFile): void {
  const blob = new Blob([JSON.stringify(file, null, 2) + "\n"], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = recoveryFileName(file);
  document.body.append(a);
  a.click();
  a.remove();
  // Revoking at once cancels the download in iOS Safari, which reads the blob only after
  // its "Download?" prompt is answered.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
